<template>
  <div>
    <!-- Inform about client does not exit error -->
    <v-container v-if="!client">
      <v-row>
        <v-col class="text-center mt-12 grand-error">
          <b>Klienti ei leitud</b><br />
          Klienti IDga {{ clientId }} ei ole olemas<br />
          või puudub sul ligipääsu tema andmetele.
        </v-col>
      </v-row>
    </v-container>

    <!-- Main -->
    <v-container v-else>
      <v-row>
        <v-avatar size="70">
          <img :src="client.avatar" alt="client profile picture" />
        </v-avatar>
        <v-col class="pl-4">
          <h1 :id="'header-for-client-' + client.id">
            {{ client.fullName }}
          </h1>
          <v-btn small text color="secondary" @click="redirectToActionForm()">
            Lisa tegevus
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-btn
            color="secondary"
            small
            text
            @click="redirectToAdminChangePage()"
          >
            <v-icon>edit</v-icon>
            <template v-if="!this.$vuetify.breakpoint.xsOnly">
              Vaata kliendi andmeid
            </template>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <Calendar person-type="client" :person-id="clientId" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { routerUrls } from '@/router'
import AccessibleClient from '@/dataAccess/models/AccessibleClient'
import Calendar from '@/components/Calendar/index.vue'
export default {
  components: {
    Calendar
  },
  data() {
    return {
      clientId: this.$route.params.Id,
      client: null
    }
  },
  created() {
    this.client = AccessibleClient.find(this.clientId)
  },
  methods: {
    redirectToAdminChangePage() {
      window.location.replace(this.client.adminChangeUrl)
    },
    redirectToActionForm() {
      // TODO perhaps use rout name and params here
      this.$router.push(`${routerUrls.addAction}?client=${this.clientId}`)
    }
  }
}
</script>

<style>
.expansion-panel__header {
  padding-left: inherit;
}
.v-expansion-panel {
  box-shadow: none;
  -webkit-box-shadow: none;
}
.theme--light .v-expansion-panel .v-expansion-panel__container,
.application .theme--light.v-expansion-panel .v-expansion-panel__container {
  background-color: inherit;
}
</style>
